module.exports = __webpack_public_path__ + "8b3bc67e97cf810301f6610146133821.MP3";